/**
 * Types to personData
 */
export const PERSON_DATA_CLEAR = '[PERSON_DATA] CLEAR';
export const PERSON_DATA_SET_DATA = '[PERSON_DATA] SET DATA';
export const PERSON_DATA_DATA_SENT = '[PERSON_DATA] DATA SENT'
export const PERSON_DATA_CLEAR_DATA_SENT = '[PERSON_DATA] CLEAR DATA SENT'
export const PERSON_DATA_UPDATE_USER_CONTACT = '[PERSON DATA] UPDATE USER CONTACT'